export default "__VITE_ASSET__CvqINg7L__"